import { Icon } from '@mch-group/uikit-components'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC } from 'react'

/**
 * @returns {JSX.Element}
 * @constructor
 */
/** This should be feasible with UIKIT (using TextLink), but it's not enough flexible. */
const SeeArtworkInWallButton: FC<ISeeArtworkInWall> = ({ label, id, cleanTitle, className }) => {
  const router = useRouter()
  const isComingFromOVRRoom = router?.query?.comingFromOVRRoom === 'true'
  return (
    <div className={className}>
      <Link
        href={{
          pathname: '/artwork',
          query: { hideFooter: true, viewInRoom: true, ...router.query, ...(isComingFromOVRRoom ? { comingFromOVRRoom: 'true' } : {}) }
        }}
        as={`/catalog/artwork/${id}/${cleanTitle}?${isComingFromOVRRoom}?viewInRoom=true${isComingFromOVRRoom ? '&comingFromOVRRoom=true' : ''}`}
        shallow
        className='d-flex align-items-center'
        legacyBehavior
      >
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a>
          <Icon name='room-view' className='me-3' />
          <span className='text-link'>{label}</span>
        </a>
      </Link>
    </div>
  )
}

interface ISeeArtworkInWall {
  label?: string,
  id?: number,
  cleanTitle?: string,
  className?: string
}

export default SeeArtworkInWallButton